import { Form, FormInstance } from 'antd';

import { IOfferStore } from 'containers/Offers/Offer/store';

import { RecursiveRequired } from 'types';

const { useWatch } = Form;

export const useFormValues = (form: FormInstance<RecursiveRequired<IOfferStore['initialValues']>>) => {
  const enTC = useWatch(['enValues', 'termsAndConditions'], form);
  const enImageUrl = useWatch(['enValues', 'imageMetadataId'], form);
  const enDisplayName = useWatch(['enValues', 'displayName'], form);
  const enDescription = useWatch(['enValues', 'description'], form);
  const frTC = useWatch(['frValues', 'termsAndConditions'], form);
  const frImageUrl = useWatch(['frValues', 'imageMetadataId'], form);
  const frDisplayName = useWatch(['frValues', 'displayName'], form);
  const frDescription = useWatch(['frValues', 'description'], form);

  const zoneId = useWatch(['zoneValue', 'displayPriorityZoneId'], form);
  const retailers = useWatch(['retailersValue', 'displayRetailers'], form);

  const name = useWatch(['genericValues', 'name'], form);
  const regions = useWatch(['genericValues', 'regions'], form);
  const displayFrom = useWatch(['genericValues', 'displayFrom'], form);
  const effectiveTo = useWatch(['genericValues', 'effectiveTo'], form);
  const effectiveFrom = useWatch(['genericValues', 'effectiveFrom'], form);
  const isParticipation = useWatch(['genericValues', 'isParticipation'], form);

  const miles = useWatch(['milesConfigurationValues', 'miles'], form);
  const offerCode = useWatch(['milesConfigurationValues', 'offerCode'], form);
  const sponsorCode = useWatch(['milesConfigurationValues', 'sponsorCode'], form);

  const enNotFilled = !enTC || !enDescription || !enImageUrl || !enDisplayName;
  const frNotFilled = !frTC || !frDescription || !frImageUrl || !frDisplayName;

  const isRetailersExist = Array.isArray(retailers) ? retailers.length : retailers;
  // we need this for new offer for validate all fields in same time
  const isSaveBtnDisabled = enNotFilled
  || frNotFilled
  || !name
  || !regions?.length
  || !effectiveFrom
  || !effectiveTo
  || !displayFrom
  || !miles
  || !offerCode
  || !sponsorCode
  || !zoneId
  || !isRetailersExist;

  return {
    enNotFilled,
    frNotFilled,
    isParticipation,
    isSaveBtnDisabled,
  };
};
